// @ts-nocheck

import { CustomSelect } from "@legacy/modules/custom-select.module.ts";

// init select

const selectEls = document.querySelectorAll(".js-custom-select");

selectEls.forEach((el) => {
    try {
        new CustomSelect(/** @type {HTMLDivElement} */ el);
    } catch (error) {
        console.error(error);
    }
});
